import { defineMessages } from 'react-intl';
import { I18nKeys } from '../../i18n/keys';

export const UserDetailsMessages = defineMessages({
  myPermissions: {
    id: I18nKeys.MyPermissions,
    defaultMessage: 'My permissions',
  },
  resetPassword: {
    id: I18nKeys.ResetPassword,
    defaultMessage: 'Change password',
  },
  newPassword: {
    id: I18nKeys.NewPassword,
    defaultMessage: 'New password',
  },
  myGroups: {
    id: I18nKeys.MyGroups,
    defaultMessage: 'My Groups',
  },
});
